export const paymentMethods = [
  "CASH",
  "CHEQUE",
  "BANK_TRANSFER_BY_TRICLES",
  "ONLINE_PAYMENT_BY_SUPERVISOR",
];

export const salaryTypes = ["REGULAR", "ADVANCE", "BONUS", "REFERRAL", "MISC"];
